export default "__VITE_ASSET__002c4385__"